<template>

<div class="dcf-grid dcf-row-gap-5 dcf-col-gap-5">
  <div class="dcf-col-100% dcf-col-25%-start@md">
    <div class="dcf-form dcf-mb-5">
      <select v-model="primalFilter">
        <option :value="null" selected>View All</option>
        <option v-for="primal in primals" :value="primal.id">{{ primal.name }}</option>
      </select>
    </div>
    <div class="unl-font-sans unl-bg-lightest-gray dcf-p-2 bov-list">
      <ul class="dcf-list-bare dcf-txt-sm">
        <li v-for="subprimal in filteredSubprimals" :class="(activeSubprimalId == subprimal.id) ? 'dcf-pl-1 active' : 'dcf-pl-1 '">
          <a class="dcf-txt-decor-none" href="#" v-on:click.prevent="activeSubprimalId = subprimal.id">
            {{ subprimal.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
    <div class="dcf-col-100% dcf-col-75%-end@md" v-if="activeSubprimalId">
      <div v-if="activeSubprimal.images.length" class="dcf-float-right dcf-ml-2 dcf-mb-2">
        <img :src="activeSubprimal.images[imageIndex]" />
        <div class="dcf-form">
          <label for="imageRotate">Rotate Image</label>
          <input id="imageRotate" class="dcf-d-block" type="range" min="0" :max="activeSubprimal.images.length - 1" v-model="imageIndex" step="1" />
        </div>
      </div>
      <h2>{{ activeSubprimal.name }}</h2>
      <div class="dcf-subhead" v-if="activeSubprimal.item_number">{{ activeSubprimal.item_number }}</div>
      
      <p>{{ activeSubprimal.description }}</p>
    </div>
  </div>
</template>

<script>

  export default {
    data: function(){
      return {
        primals: [],
        subprimals: [],
        primalFilter: null,
        activeSubprimalId: false,
        imageIndex: 0
      }
    },
    computed: {
      filteredSubprimals: function(){
        var $this = this;
        var output = this.subprimals;
        if(this.primalFilter){
          output = output.filter(function(e, i, a){
            return e.primal_id == $this.primalFilter;
          });
        }

        return output;
      },
      activeSubprimal: function(){
        var $this = this;
        return this.activeSubprimalId ? this.subprimals.find( function(v){ return v.id == $this.activeSubprimalId }) : false;
      }
    },
    methods: {

    },
    created: function(){
      this.primals = window.primals;
      this.subprimals = window.subprimals;
    },
    watch: {
      activeSubprimalId: function(o, n){
        this.imageIndex = 0; 
      }
    }
  }
</script>
